export const CENTERX_DIVIDER = 2;
export const CENTERY_DIVIDER = 2;
export const SCALE_DIVIDER = 33;
export const SCALE_MULTIPLIER = 2;
export const BADGE_OFFSET_MULTIPLIER = 0.8;
export const PATH_CENTERY = 24.5;
